import { render, staticRenderFns } from "./tsView.vue?vue&type=template&id=420d71fe&scoped=true"
import script from "./tsView.vue?vue&type=script&lang=js"
export * from "./tsView.vue?vue&type=script&lang=js"
import style0 from "./tsView.vue?vue&type=style&index=0&id=420d71fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420d71fe",
  null
  
)

export default component.exports